var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "11", height: "9", viewBox: "0 0 11 9" }, props),
    React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M3.648 6.352L9.293.707a1 1 0 1 1 1.414 1.414L4.355 8.473a1 1 0 0 1-1.414 0L.707 6.239a1 1 0 0 1 1.414-1.414l1.527 1.527z" })
  );
});